import {
  Angle,
  DEFAULT_ANCHOR_BY_TYPE,
  ElementState,
  ElementType,
  THICKNESS_PRESETS,
} from '@ritabygglov/core';

export const createAngle = (
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string
): Angle => {
  return {
    id,
    type: ElementType.Angle,
    text: ' ',
    pointRatio: 0.5,
    x: initialX,
    y: initialY,
    width: 100,
    height: 100,
    state: ElementState.Creation,
    rotate: 0,
    renderingOrder,
    style: {
      fill: 'transparent',
      stroke: '#000',
    },
    thickness: THICKNESS_PRESETS.M,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Angle],
    userVersion: {
      userId,
      version: 1,
    },
    showDimensions: false,
    diagonalHatch: false,
  };
};
